import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-footer-pagination',
  templateUrl: './footer-pagination.component.html',
  styleUrls: ['./footer-pagination.component.scss']
})
export class FooterPaginationComponent {
  @Input() totalItems: number
  @Input() itemsPerPage: number = 10
  @Input() page: number = 1
  @Output() onPageChanged = new EventEmitter();

  itemsPerPageChanged(event){
    this.onPageChanged.emit({
      itemsPerPage: this.itemsPerPage,
      page: this.page
    });
  }

  pageChanged(event){
    this.onPageChanged.emit(event);
  }
}
